import { Link } from 'react-router-dom';
import { Linkedin, Mail, ArrowUpRight } from 'lucide-react';
import { FOOTER } from '@/lib/testIds';

export default function Footer() {
  return (
    <footer data-testid={FOOTER.root} className="relative border-t border-white/10 bg-[#040914]">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-cyan-400/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-cyan-400 to-purple-500 grid place-items-center font-heading font-bold text-[#040914] text-lg">
              S
            </div>
            <div className="leading-tight">
              <div className="font-heading text-base font-semibold">SKV Digital Labs</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-brand-ink">AI Growth · Transformation</div>
            </div>
          </div>
          <p className="mt-5 max-w-md text-sm text-white/60 leading-relaxed">
            A global AI-powered growth and digital transformation consultancy. We help ambitious
            businesses scale through performance marketing, automation, analytics, and AI-led
            operating models.
          </p>

          <div className="mt-6 flex items-center gap-3">
            <a
              href="https://www.linkedin.com/in/sanjay-varma/"
              target="_blank"
              rel="noreferrer noopener"
              data-testid={FOOTER.linkedin}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/10 hover:border-cyan-400/40 hover:text-cyan-300 transition-colors text-sm"
            >
              <Linkedin className="w-4 h-4" /> LinkedIn
            </a>
            <a
              href="mailto:hello@skvdigitallabs.com"
              data-testid={FOOTER.email}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/10 hover:border-cyan-400/40 hover:text-cyan-300 transition-colors text-sm"
            >
              <Mail className="w-4 h-4" /> hello@skvdigitallabs.com
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.22em] text-brand-ink mb-4">Navigate</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/" className="text-white/70 hover:text-cyan-300">Home</Link></li>
            <li><Link to="/about" className="text-white/70 hover:text-cyan-300">About / Founder</Link></li>
            <li><Link to="/services" className="text-white/70 hover:text-cyan-300">Services</Link></li>
            <li><Link to="/case-studies" className="text-white/70 hover:text-cyan-300">Case Studies</Link></li>
            <li><Link to="/testimonials" className="text-white/70 hover:text-cyan-300">Testimonials</Link></li>
            <li><Link to="/contact" className="text-white/70 hover:text-cyan-300">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.22em] text-brand-ink mb-4">Ready to grow?</div>
          <Link
            to="/contact"
            className="group inline-flex items-center justify-between w-full px-5 py-4 rounded-2xl glass hover:border-cyan-400/30 transition-colors"
          >
            <span className="font-heading text-lg">Book a Strategy Call</span>
            <ArrowUpRight className="w-5 h-5 text-cyan-300 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </Link>
          <p className="mt-4 text-xs text-white/40 leading-relaxed">
            Serving US · UK · Europe · UAE · APAC · Australia · India
          </p>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <div>© {new Date().getFullYear()} SKV Digital Labs. All rights reserved.</div>
          <div className="font-mono-display tracking-wider">AI · GROWTH · TRANSFORMATION</div>
        </div>
      </div>
    </footer>
  );
}
